export const azureImagePaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/images`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/images`,
  detail: (connectionId, resourceGroup, name) =>
    `/compute/cloud-account-connections/${connectionId}/azure/images/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}`,
};
